import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Checkbox, Table } from 'antd';
const CertificateDialogDataTable = ({ data, tableDataItem, radioBoxCheckBox, onSelectedKeysChange, }) => {
    const [tableData, setTableData] = useState([]);
    const [checkedRows, setCheckedRows] = useState(new Set());
    const [isRadioBoxCheckBox, setIsRadioBoxCheckBox] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        setIsRadioBoxCheckBox(radioBoxCheckBox === "option6" || radioBoxCheckBox === "option3");
        if (data) {
            const newData = data.map((item, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                let renewalRequiredValue = 3;
                if ((item === null || item === void 0 ? void 0 : item.boolShowRenewalCertSelectOption) == true &&
                    ((_a = item === null || item === void 0 ? void 0 : item.objLuCertVerification) === null || _a === void 0 ? void 0 : _a.intId) == 1806 &&
                    ((_b = item === null || item === void 0 ? void 0 : item.objCertStatus) === null || _b === void 0 ? void 0 : _b.intId) != 4 &&
                    (item === null || item === void 0 ? void 0 : item.intIACert) != 2) {
                    renewalRequiredValue = 1;
                }
                else if (((_c = item === null || item === void 0 ? void 0 : item.objCertRenewalStatus) === null || _c === void 0 ? void 0 : _c.intId) == 6030 && item.intIACert != 2) {
                    renewalRequiredValue = 2;
                }
                return {
                    key: index,
                    entityname: `${(_d = item.objLuCompany) === null || _d === void 0 ? void 0 : _d.strLongDesc}`,
                    productmodel: `${item.strSeriesModel}`,
                    brand: `${(_e = item === null || item === void 0 ? void 0 : item.objBrandName) === null || _e === void 0 ? void 0 : _e.strLongDesc}`,
                    country: `${(_f = item === null || item === void 0 ? void 0 : item.objLuCountry) === null || _f === void 0 ? void 0 : _f.strLongDesc}`,
                    certificatename: `${item.strServiceName}`,
                    certificateid: `${item.strCertId}`,
                    issuedate: convertDate(`${item.dtCertDate}`),
                    expirationdate: convertDate(`${item.dtCertExpDate}`),
                    certificatestatus: `${(_g = item === null || item === void 0 ? void 0 : item.objCertStatus) === null || _g === void 0 ? void 0 : _g.strLongDesc}`,
                    decisiondate: convertDate(`${item.dtRenewalDate}`),
                    renewalstatus: `${(_h = item === null || item === void 0 ? void 0 : item.objCertRenewalStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc}`,
                    renewalRequired: renewalRequiredValue,
                    strSeriesModel: `${item.strSeriesModel}`,
                };
            });
            setTableData(newData);
        }
    }, [data, radioBoxCheckBox, isRadioBoxCheckBox]);
    useEffect(() => {
        onSelectedKeysChange(checkedRows);
    }, [checkedRows, onSelectedKeysChange]);
    const handleCheckboxChange = (key, checked) => {
        setCheckedRows(prev => {
            const newCheckedRows = new Set(prev);
            if (checked) {
                newCheckedRows.add(key);
            }
            else {
                newCheckedRows.delete(key);
            }
            return newCheckedRows;
        });
    };
    const columns = [
        isRadioBoxCheckBox && {
            title: '',
            dataIndex: 'checkbox',
            key: 'checkbox',
            width: 40,
            fixed: 'left',
            render: (_, record) => (_jsx(Checkbox, { checked: checkedRows.has(record.key), onChange: e => handleCheckboxChange(record.key, e.target.checked) })),
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brand',
            key: 'brand',
            width: 120,
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            width: 120,
        },
        {
            title: 'Certificate Name',
            dataIndex: 'certificatename',
            key: 'certificatename',
            width: 140,
        },
        {
            title: 'Certificate ID',
            dataIndex: 'certificateid',
            key: 'certificateid',
            width: 120,
        },
        {
            title: 'Issue Date',
            dataIndex: 'issuedate',
            key: 'issuedate',
            width: 120,
        },
        {
            title: 'Expiration Date',
            dataIndex: 'expirationdate',
            key: 'expirationdate',
            width: 140,
        },
        {
            title: 'Recommended Decision Date',
            dataIndex: 'decisiondate',
            key: 'decisiondate',
            width: 140,
        },
        {
            title: 'Certificate Status',
            dataIndex: 'certificatestatus',
            key: 'certificatestatus',
            width: 100,
        },
        {
            title: 'Renewal Status',
            dataIndex: 'renewalstatus',
            key: 'renewalstatus',
            width: 100,
        },
    ].filter(Boolean);
    const rowClassName = (record, index) => {
        if (currentPage === 1 && index === 0) {
            return 'renew-cert-dialog-first-row';
        }
        return '';
    };
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
          .renew-cert-dialog-first-row {
            color: blue;
          }
        ` }), _jsx(Table, { bordered: true, columns: columns.filter(_ => _ !== undefined), dataSource: tableDataItem ? [tableDataItem] : tableData, scroll: { x: 1200 }, pagination: {
                    onChange: (page) => setCurrentPage(page),
                }, rowClassName: rowClassName })] }));
};
export default CertificateDialogDataTable;
function convertDate(dateString) {
    let [datePart, timePart] = dateString.split(' ');
    let [day, month, year] = datePart.split('/').map(Number);
    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let formattedMonth = monthNames[month - 1];
    let formattedDate = `${day}-${formattedMonth}-${year}`;
    return formattedDate;
}
